import { Spacer } from "@aircall/tractor";
import { styled } from "@xstyled/styled-components";

export const StyledSpacer = styled(Spacer)`
  color: #004736;
  background: linear-gradient(225deg, #f5fffb 0%, #c2ffec 100%);
`;
